export function hasValue(value: string | number | boolean | null | undefined): boolean {
  return value !== undefined && value !== null && value !== ''
}
